import {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099When.module.scss'
const cx = cn.bind(s)

interface IMake1099WhenProps {
	className?: string
	content: IMake1099Content['when']
}

/** Make1099When block component */
const Make1099When: FC<IMake1099WhenProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.description} />
				<div className={cx('deadline')}>
					<p className={cx('deadline__title', 'ta-center', 'h3')}>{content?.deadline?.title}</p>
					<p className={cx('deadline__description', 'ta-center')}>
						{content?.deadline?.description}
					</p>
				</div>
			</Container>
		</div>
	)
}

Make1099When.displayName = 'Make1099When'

export default Make1099When
